import axios from 'axios'

export default {
  namespaced: true,
  state: {
    allProjetos: [],
    projeto: null,
    allResponsaveis: [],
    responsaveis: [],
    equipes: [],
    solicitantes: [],
    sistemas: [],
    tiposSistema: [],
    situacoesProjeto: [],
    situacoesDetalhe: [],
    dificuldades: [],
    etapas: []
  },
  actions: {
    fetchAll({ dispatch }, { config, actions }) {
      const promises = actions.map((action) => {
        return dispatch('fetch' + action, config)
      })

      return Promise.all(promises)
    },
    fetchAllProjetos({ commit, rootState }, config) {
      return new Promise((resolve, reject) =>
        axios
          .get(rootState.baseUrlGestaoProjetos + 'Projeto/Listar', config)
          .then(({ data }) => {
            commit('SET_ALL_PROJETOS', data)
            resolve()
          })
          .catch(reject)
      )
    },
    fetchProjeto({ commit, rootState }, id, config) {
      return new Promise((resolve, reject) =>
        axios
          .get(rootState.baseUrlGestaoProjetos + 'Projeto/ListarProjetoPorIdProjeto/' + id, config)
          .then(({ data }) => {
            commit('SET_PROJETO', data)
            resolve()
          })
          .catch(reject)
      )
    },
    fetchSolicitantes({ commit, rootState }, config) {
      return new Promise((resolve, reject) =>
        axios
          .get(rootState.baseUrlSegurancaSGP + `Cadastro/ListartodosloginSemBloqueio`, config)
          .then(({ data }) => {
            commit(
              'SET_SOLICITANTES',
              data.map((item) => ({
                ...item,
                descricao: item.usuariocomplemento.usucompnome
              }))
            )
            resolve()
          })
          .catch(reject)
      )
    },
    fetchAllResponsaveis({ commit, rootState }, config) {
      return new Promise((resolve, reject) =>
        axios
          .get(rootState.baseUrlGestaoProjetos + `ProjetoResponsavel/Listar`, config)
          .then(({ data }) => {
            commit('SET_ALL_RESPONSAVEIS', data)
            resolve()
          })
          .catch(reject)
      )
    },
    fetchResponsaveis({ commit, rootState }, idEquipe, config) {
      return new Promise((resolve, reject) =>
        axios
          .get(
            rootState.baseUrlGestaoProjetos +
              `ProjetoResponsavel/ListarProjetoResponsavelPorIdEquipe/` +
              idEquipe,
            config
          )
          .then(({ data }) => {
            commit('SET_RESPONSAVEIS', data)
            resolve()
          })
          .catch(reject)
      )
    },
    fetchEquipes({ commit, rootState }, config) {
      return new Promise((resolve, reject) =>
        axios
          .get(rootState.baseUrlGestaoProjetos + `Equipe/Listar`, config)
          .then(({ data }) => {
            commit('SET_EQUIPES', data)
            resolve()
          })
          .catch(reject)
      )
    },
    fetchSistemas({ commit, rootState }, config) {
      return new Promise((resolve, reject) =>
        axios
          .get(rootState.baseUrlGestaoProjetos + `SistemasFcc/Listar`, config)
          .then(({ data }) => {
            commit('SET_SISTEMAS', data)
            resolve()
          })
          .catch(reject)
      )
    },
    fetchTiposSistema({ commit, rootState }, config) {
      return new Promise((resolve, reject) =>
        axios
          .get(rootState.baseUrlGestaoProjetos + `TipoSistema/Listar`, config)
          .then(({ data }) => {
            commit('SET_TIPOS_SISTEMA', data)
            resolve()
          })
          .catch(reject)
      )
    },
    fetchSituacoesProjeto({ commit, rootState }, config) {
      return new Promise((resolve, reject) =>
        axios
          .get(rootState.baseUrlGestaoProjetos + `TipoSituacaoProjeto/Listar`, config)
          .then(({ data }) => {
            commit('SET_SITUACOES_PROJETO', data)
            resolve()
          })
          .catch(reject)
      )
    },
    fetchSituacoesDetalhe({ commit, rootState }, config) {
      return new Promise((resolve, reject) =>
        axios
          .get(rootState.baseUrlGestaoProjetos + `TipoSituacaoDetalhe/Listar`, config)
          .then(({ data }) => {
            commit('SET_SITUACOES_DETALHE', data)
            resolve()
          })
          .catch(reject)
      )
    },
    fetchResponsavel({ commit, rootState }, config) {
      return new Promise((resolve, reject) =>
        axios
          .get(rootState.baseUrlGestaoProjetos + `TipoSituacaoProjeto/Listar`, config)
          .then(({ data }) => {
            commit('SET_SITUACOES_PROJETO', data)
            resolve()
          })
          .catch(reject)
      )
    },
    fetchDificuldades({ commit, rootState }, config) {
      return new Promise((resolve, reject) =>
        axios
          .get(rootState.baseUrlGestaoProjetos + `TipoDificuldade/Listar`, config)
          .then(({ data }) => {
            commit('SET_DIFICULDADES', data)
            resolve()
          })
          .catch(reject)
      )
    },
    fetchEtapas({ commit, rootState, dispatch, state }, idProjeto, config) {
      return new Promise((resolve, reject) =>
        axios
          .get(
            rootState.baseUrlGestaoProjetos +
              `ProjetoDetalhe/ListarProjetoDetalhePorIdProjeto/${idProjeto}`,
            config
          )
          .then(({ data }) => {
            commit('SET_ETAPAS', data)
          })
          .then(() => dispatch('fetchAllResponsaveis', config))
          .then(() => {
            const etapasComResponsavelEquipe = state.etapas.map((etapa) => {
              const responsavel = state.allResponsaveis.find(
                (resp) => resp.idresponsavel === etapa.idresponsavel
              )

              return {
                ...etapa,
                responsavel,
                equipe: {
                  idequipe: responsavel.idequipe,
                  descricaoequipe: responsavel.descricaoequipe
                }
              }
            })
            commit('SET_ETAPAS', etapasComResponsavelEquipe)
            resolve()
          })
          .catch(reject)
      )
    }
  },
  mutations: {
    SET_ALL_PROJETOS(state, data) {
      state.allProjetos = data
    },
    SET_PROJETO(state, data) {
      state.projeto = data
    },
    SET_SOLICITANTES(state, data) {
      state.solicitantes = data
    },
    SET_RESPONSAVEIS(state, data) {
      state.responsaveis = data
    },
    SET_ALL_RESPONSAVEIS(state, data) {
      state.allResponsaveis = data
    },
    SET_EQUIPES(state, data) {
      state.equipes = data
    },
    SET_SISTEMAS(state, data) {
      state.sistemas = data
    },
    SET_TIPOS_SISTEMA(state, data) {
      state.tiposSistema = data
    },
    SET_SITUACOES_PROJETO(state, data) {
      state.situacoesProjeto = data
    },
    SET_SITUACOES_DETALHE(state, data) {
      state.situacoesDetalhe = data
    },
    SET_DIFICULDADES(state, data) {
      state.dificuldades = data
    },
    SET_ETAPAS(state, data) {
      state.etapas = data
    }
  }
}
